import { gql } from '@apollo/client';

const StoreInfo = gql`
  fragment StoreInfo on Store {
    id
    name
    description
    createdAt
    updatedAt
  }
`;

export default StoreInfo;
